/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Scope_InstanceInputs */

const en_adm_scope_instance = /** @type {(inputs: Adm_Scope_InstanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whole instance`)
};

const de_adm_scope_instance = /** @type {(inputs: Adm_Scope_InstanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganze Instanz`)
};

/**
* | output |
* | --- |
* | "Whole instance" |
*
* @param {Adm_Scope_InstanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_scope_instance = /** @type {((inputs?: Adm_Scope_InstanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Scope_InstanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_scope_instance(inputs)
	return en_adm_scope_instance(inputs)
});